import React, { useEffect, useState } from 'react';
import '../../css/bootstrap.min.css';
import '../../css/feathericon.min.css';
import '../../css/font-awesome.min.css';
import '../../css/style.css';
import '../../plugins/datatables/datatables.min.css';
import AdminSidebar from '../Adminsidebar/AdminSidebar';
import '../../css/admin-sidebar.css'; // Ensure the correct path to your CSS
import logo from "../../../assets/img/logo.png"


function Transaction() {
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  useEffect(() => {
    // Initialize DataTables after component mounts
    if (window.$) {
      window.$('.datatable').DataTable();
    }
  }, []);
  const handleDeleteModal = () => {
    setShowDeleteModal(true);
  };
  const handleCloseModal = () => {
    setShowDeleteModal(false);
  };
     const [activeLink, setActiveLink] = useState(null);
  
      const handleLinkClick = (link) => {
          setActiveLink(link);
      };
          const [isOpen, setIsOpen] = useState(false);
        const toggleSidebar = () => {
          setIsOpen(!isOpen);
        };
      
  return (
    <div className="main-wrapper">
  <div className="hitkari-header">
        <div className="hitkari-header-left">
          <a href="/dash" className="hitkari-logo">
            <img src={logo} alt="Hitkari Logo" />
          </a>
          <button className="hitkari-sidebar-toggle" onClick={toggleSidebar}>
            <i className="fa fa-bars"></i>
          </button>
        </div>
      </div>

      <div className={`hitkari-sidebar ${isOpen ? 'hitkari-sidebar-open' : ''}`} id="hitkari-sidebar">
        <div className="hitkari-sidebar-inner slimscroll">
          <div id="hitkari-sidebar-menu" className="hitkari-sidebar-menu">
            <ul>
              <li className="hitkari-menu-title">
                <span>Main</span>
              </li>
              <li>
                <a
                  href="/dash"
                  className={`hitkari-menu-link ${activeLink === 'dashboard' ? 'hitkari-active-admin' : ''}`}
                  onClick={() => handleLinkClick('dashboard')}
                >
                  <i className="fe fe-home"></i> <span>Dashboard</span>
                </a>
              </li>
              <li>
                                    <a
                                        href="/adddoctorprofile"
                                        className={`hitkari-menu-link ${activeLink === 'adddoctorprofile' ? 'hitkari-active-admin' : ''}`}
                                        onClick={() => handleLinkClick('adddoctorprofile')}
                                    >
                                        <i className="fe fe-activity"></i> <span>Add Doctor Profile</span>
                                    </a>
                                </li>
              <li>
                <a
                  href="/appoint"
                  className={`hitkari-menu-link ${activeLink === 'appointments' ? 'hitkari-active-admin' : ''}`}
                  onClick={() => handleLinkClick('appointments')}
                >
                  <i className="fe fe-layout"></i> <span>Appointments</span>
                </a>
              </li>
              <li>
                <a
                  href="/tester"
                  className={`hitkari-menu-link ${activeLink === 'specialities' ? 'hitkari-active-admin' : ''}`}
                  onClick={() => handleLinkClick('specialities')}
                >
                  <i className="fe fe-users"></i> <span>Specialities</span>
                </a>
              </li>
              <li>
                <a
                  href="/doctor"
                  className={`hitkari-menu-link ${activeLink === 'doctors' ? 'hitkari-active-admin' : ''}`}
                  onClick={() => handleLinkClick('doctors')}
                >
                  <i className="fe fe-user-plus"></i> <span>Doctors</span>
                </a>
              </li>

              <li>
                <a
                  href="/tran"
                  className={`hitkari-menu-link ${activeLink === 'transactions' ? 'hitkari-active-admin' : ''}`}
                  onClick={() => handleLinkClick('transactions')}
                >
                  <i className="fe fe-activity"></i> <span>Transactions</span>
                </a>
              </li>
              <li>
                <a
                  href="/addblogs"
                  className={`hitkari-menu-link ${activeLink === 'Blogs' ? 'hitkari-active-admin' : ''}`}
                  onClick={() => handleLinkClick('Blogs')}
                >
                  <i className="fe fe-activity"></i> <span>Blogs</span>
                </a>
              </li>
              <li>
                <a
                  href="/addgallery"
                  className={`hitkari-menu-link ${activeLink === 'Gallery' ? 'hitkari-active-admin' : ''}`}
                  onClick={() => handleLinkClick('Gallery')}
                >
                  <i className="fe fe-activity"></i> <span>Gallery</span>
                </a>
              </li>
              <li>
                <a
                  href="/addvideos"
                  className={`hitkari-menu-link ${activeLink === 'Videos' ? 'hitkari-active-admin' : ''}`}
                  onClick={() => handleLinkClick('Videos')}
                >
                  <i className="fe fe-activity"></i> <span>Videos</span>
                </a>
              </li>
              <li>
                <a
                  href="/addcarousel"
                  className={`hitkari-menu-link ${activeLink === 'Carousel' ? 'hitkari-active-admin' : ''}`}
                  onClick={() => handleLinkClick('Carousel')}
                >
                  <i className="fe fe-activity"></i> <span>Carousel</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
     
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Transactions</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="index.html">Dashboard</a>
                  </li>
                  <li className="breadcrumb-item active">Transactions</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="datatable table table-hover table-center mb-0">
                      <thead>
                        <tr>
                          <th>Invoice Number</th>
                          <th>Patient ID</th>
                          <th>Patient Name</th>
                          <th>Total Amount</th>
                          <th className="text-center">Status</th>
                          <th className="text-right">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <a href="invoice.html">#IN0001</a>
                          </td>
                          <td>#PT001</td>
                          <td>
                            <h2 className="table-avatar">
                              <a href="profile.html" className="avatar avatar-sm mr-2">
                                <img
                                  className="avatar-img rounded-circle"
                                  src="/admin/img/patients/patient1.jpg"
                                  alt="User Image"
                                />
                              </a>
                              <a href="profile.html">Charlene Reed </a>
                            </h2>
                          </td>
                          <td>$100.00</td>
                          <td className="text-center">
                            <span className="badge badge-pill bg-success inv-badge">Paid</span>
                          </td>
                          <td className="text-right">
                            <div className="actions">
                              <button onClick={handleDeleteModal} className="btn btn-sm bg-danger-light">
                                <i className="fe fe-trash"></i> Delete
                              </button>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <a href="invoice.html">#IN0002</a>
                          </td>
                          <td>#PT002</td>
                          <td>
                            <h2 className="table-avatar">
                              <a href="profile.html" className="avatar avatar-sm mr-2">
                                <img
                                  className="avatar-img rounded-circle"
                                  src="/admin/img/patients/patient2.jpg"
                                  alt="User Image"
                                />
                              </a>
                              <a href="profile.html">Travis Trimble </a>
                            </h2>
                          </td>
                          <td>$200.00</td>
                          <td className="text-center">
                            <span className="badge badge-pill bg-success inv-badge">Paid</span>
                          </td>
                          <td className="text-right">
                            <div className="actions">
                              <button onClick={handleDeleteModal} className="btn btn-sm bg-danger-light">
                                <i className="fe fe-trash"></i> Delete
                              </button>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <a href="invoice.html">#IN0003</a>
                          </td>
                          <td>#PT003</td>
                          <td>
                            <h2 className="table-avatar">
                              <a href="profile.html" className="avatar avatar-sm mr-2">
                                <img
                                  className="avatar-img rounded-circle"
                                  src="/admin/img/patients/patient3.jpg"
                                  alt="User Image"
                                />
                              </a>
                              <a href="profile.html">Carl Kelly</a>
                            </h2>
                          </td>
                          <td>$250.00</td>
                          <td className="text-center">
                            <span className="badge badge-pill bg-success inv-badge">Paid</span>
                          </td>
                          <td className="text-right">
                            <div className="actions">
                             <button onClick={handleDeleteModal} className="btn btn-sm bg-danger-light">
                                <i className="fe fe-trash"></i> Delete
                              </button>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <a href="invoice.html">#IN0004</a>
                          </td>
                          <td>#PT004</td>
                          <td>
                            <h2 className="table-avatar">
                              <a href="profile.html" className="avatar avatar-sm mr-2">
                                <img
                                  className="avatar-img rounded-circle"
                                  src="/admin/img/patients/patient4.jpg"
                                  alt="User Image"
                                />
                              </a>
                              <a href="profile.html"> Michelle Fairfax</a>
                            </h2>
                          </td>
                          <td>$150.00</td>
                          <td className="text-center">
                            <span className="badge badge-pill bg-success inv-badge">Paid</span>
                          </td>
                          <td className="text-right">
                            <div className="actions">
                            <button onClick={handleDeleteModal} className="btn btn-sm bg-danger-light">
                                <i className="fe fe-trash"></i> Delete
                              </button>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <a href="invoice.html">#IN0005</a>
                          </td>
                          <td>#PT005</td>
                          <td>
                            <h2 className="table-avatar">
                              <a href="profile.html" className="avatar avatar-sm mr-2">
                                <img
                                  className="avatar-img rounded-circle"
                                  src="/admin/img/patients/patient5.jpg"
                                  alt="User Image"
                                />
                              </a>
                              <a href="profile.html">Gina Moore</a>
                            </h2>
                          </td>
                          <td>$350.00</td>
                          <td className="text-center">
                            <span className="badge badge-pill bg-success inv-badge">Paid</span>
                          </td>
                           <td className="text-right">
                            <div className="actions">
                            <button onClick={handleDeleteModal} className="btn btn-sm bg-danger-light">
                                <i className="fe fe-trash"></i> Delete
                              </button>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <a href="invoice.html">#IN0006</a>
                          </td>
                          <td>#PT006</td>
                          <td>
                            <h2 className="table-avatar">
                              <a href="profile.html" className="avatar avatar-sm mr-2">
                                <img
                                  className="avatar-img rounded-circle"
                                  src="/admin/img/patients/patient6.jpg"
                                  alt="User Image"
                                />
                              </a>
                              <a href="profile.html">Elsie Gilley</a>
                            </h2>
                          </td>
                          <td>$300.00</td>
                          <td className="text-center">
                            <span className="badge badge-pill bg-success inv-badge">Paid</span>
                          </td>
                          <td className="text-right">
                            <div className="actions">
                             <button onClick={handleDeleteModal} className="btn btn-sm bg-danger-light">
                                <i className="fe fe-trash"></i> Delete
                              </button>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <a href="invoice.html">#IN0007</a>
                          </td>
                          <td>#PT007</td>
                          <td>
                            <h2 className="table-avatar">
                              <a href="profile.html" className="avatar avatar-sm mr-2">
                                <img
                                  className="avatar-img rounded-circle"
                                  src="/admin/img/patients/patient7.jpg"
                                  alt="User Image"
                                />
                              </a>
                              <a href="profile.html"> Joan Gardner</a>
                            </h2>
                          </td>
                          <td>$250.00</td>
                          <td className="text-center">
                            <span className="badge badge-pill bg-success inv-badge">Paid</span>
                          </td>
                          <td className="text-right">
                            <div className="actions">
                             <button onClick={handleDeleteModal} className="btn btn-sm bg-danger-light">
                                <i className="fe fe-trash"></i> Delete
                              </button>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <a href="invoice.html">#IN0008</a>
                          </td>
                          <td>#PT008</td>
                          <td>
                            <h2 className="table-avatar">
                              <a href="profile.html" className="avatar avatar-sm mr-2">
                                <img
                                  className="avatar-img rounded-circle"
                                  src="/admin/img/patients/patient8.jpg"
                                  alt="User Image"
                                />
                              </a>
                              <a href="profile.html"> Daniel Griffing</a>
                            </h2>
                          </td>
                          <td>$150.00</td>
                          <td className="text-center">
                            <span className="badge badge-pill bg-success inv-badge">Paid</span>
                          </td>
                           <td className="text-right">
                            <div className="actions">
                             <button onClick={handleDeleteModal} className="btn btn-sm bg-danger-light">
                                <i className="fe fe-trash"></i> Delete
                              </button>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <a href="invoice.html">#IN0009</a>
                          </td>
                          <td>#PT009</td>
                          <td>
                            <h2 className="table-avatar">
                              <a href="profile.html" className="avatar avatar-sm mr-2">
                                <img
                                  className="avatar-img rounded-circle"
                                  src="/admin/img/patients/patient9.jpg"
                                  alt="User Image"
                                />
                              </a>
                              <a href="profile.html">Walter Roberson</a>
                            </h2>
                          </td>
                          <td>$100.00</td>
                          <td className="text-center">
                            <span className="badge badge-pill bg-success inv-badge">Paid</span>
                          </td>
                           <td className="text-right">
                            <div className="actions">
                             <button onClick={handleDeleteModal} className="btn btn-sm bg-danger-light">
                                <i className="fe fe-trash"></i> Delete
                              </button>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <a href="invoice.html">#IN0010</a>
                          </td>
                          <td>#PT010</td>
                          <td>
                            <h2 className="table-avatar">
                              <a href="profile.html" className="avatar avatar-sm mr-2">
                                <img
                                  className="avatar-img rounded-circle"
                                  src="/admin/img/patients/patient10.jpg"
                                  alt="User Image"
                                />
                              </a>
                              <a href="profile.html">Robert Rhodes </a>
                            </h2>
                          </td>
                          <td>$120.00</td>
                          <td className="text-center">
                            <span className="badge badge-pill bg-success inv-badge">Paid</span>
                          </td>
                          <td className="text-right">
                            <div className="actions">
                             <button onClick={handleDeleteModal} className="btn btn-sm bg-danger-light">
                                <i className="fe fe-trash"></i> Delete
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {showDeleteModal && (
          <div className="modal fade show" style={{ display: 'block' }}>
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-body">
                  <div className="form-content p-2">
                    <h4 className="modal-title">Delete</h4>
                    <p className="mb-4">Are you sure want to delete?</p>
                    <button type="button" className="btn btn-primary">
                      Save{' '}
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger"
                      data-dismiss="modal"
                      onClick={handleCloseModal}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
export default Transaction;